import * as Oidc from 'oidc-client';

export class Settings {
    get idp(): Oidc.OidcClientSettings {
        var idpSettings: Oidc.OidcClientSettings = {
            authority: process.env.REACT_APP_authority,
            client_id: process.env.REACT_APP_client_id,
            client_secret: process.env.REACT_APP_client_secret, // just don't use auth?
            redirect_uri: process.env.REACT_APP_redirect_uri,
            response_type: process.env.REACT_APP_response_type,
            scope: process.env.REACT_APP_scope,
            post_logout_redirect_uri: process.env.REACT_APP_post_logout_redirect_uri,
        };

        return idpSettings;
    }

    get apiServer(): string  {
        const apiServer = process.env.REACT_APP_api_server;
        if ( !apiServer ) throw new Error('setting missing');
        console.debug(`API server: ${apiServer}`);
        return apiServer;        
    }
}

var instance: Settings;
export default function get(): Settings {
    if ( !instance ) {
        instance = new Settings();
    }

    return instance;
}


// WEBPACK FOOTER //
// ./src/app/services/Settings.ts